export enum RowState {
  Expanded,
  Collapsed,
}
